import React from 'react'
import {
  Button,
  ContextMenu,
  CONTEXT_MENU_SIZE_SM,
  makeButtonWithMenu,
  toastShow,
  TOAST_VARIANT_SUCCESS
} from 'mailup-web-components'
import { useRecoilCallback } from 'recoil'
import { exportResults } from '../recoil/callbacks/callbacks'

import './ExportButton.scss'
import { useIntl } from 'react-intl'

const ExportButton = () => {
  const intl = useIntl()
  const exportMessages = useRecoilCallback(exportResults)

  const handleClickItem = value => {
    exportMessages(value, () => {
      toastShow(
        intl.formatMessage({ id: 'Load.Common.ExportSuccess' }),
        TOAST_VARIANT_SUCCESS,
        'exportMessages',
        true
      )
    })
  }

  const ButtonComponent = () => (
    <Button kind='secondary' data-mu-test='btn-export-all' className='test-exportAll'>
      {intl.formatMessage({ id: 'Load.EmailMessageList.ActionExportAll' })}
    </Button>
  )
  const MenuComponent = () => (
    <ContextMenu
      size={CONTEXT_MENU_SIZE_SM}
      items={[
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportCSV' }),
          value: 'CSV',
          onClick: handleClickItem
        },
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportXLSXX' }),
          value: 'XLSL',
          onClick: handleClickItem
        },
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportVisualReport' }),
          value: 'REPORTXLS',
          onClick: handleClickItem
        }
      ]}
    />
  )
  const ButtonWithMenu = makeButtonWithMenu(ButtonComponent, MenuComponent)

  return (
    <div className='c-messages-list-export-container'>
      <ButtonWithMenu className='c-messages-list-export' />
    </div>
  )
}

export default ExportButton
